import {Loader, Text, TextButton} from '@smart/web-components';
import * as React from 'react';
import styles from './calculator-skeleton.module.scss';

export interface CalculatorSkeletonProps {
  readonly status: 'pending' | 'fallback' | 'completed';
  readonly onErrorRetry: () => void;
}

export function CalculatorSkeleton({
  status,
  onErrorRetry,
}: CalculatorSkeletonProps): JSX.Element {
  return (
    <div className={styles.loaderWrapper}>
      {(() => {
        switch (status) {
          case `pending`:
            return null;
          case `fallback`:
            return <Loader messageId={React.useId()} size="medium" />;
          case `completed`:
            return (
              <>
                <Text variant="paragraph-100" className={styles.errorMessage}>
                  An unexpected error occured. Please try again.
                </Text>
                <TextButton variant="primary" onClick={onErrorRetry}>
                  Retry
                </TextButton>
              </>
            );
        }
      })()}
    </div>
  );
}
